import styled from 'styled-components';
import { SectionParent, BlueButton } from '../../StyledComponents';
import React from 'react';
import Android from '../../../assets/v2/androidx86/group-8.svg';
import { navigate } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import KioskBg from '../../../assets/v2/androidx86/slack.jpg';
import { Title } from '../HomePage/HomepageSectionOne';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  padding-top: 8rem !important;
  background-size: cover;
  padding-bottom: 5rem;
  background-image: linear-gradient(-180deg, #0000005c, #1b2241),
    url(${KioskBg});
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    background-size: cover;
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    background-image: linear-gradient(-180deg, #00000078, transparent),
      url(${KioskBg});
    background-size: cover;
    padding-top: 8rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  display: grid;
  justify-items: center;
  @media (max-width: 520px) {
    padding-left: 0rem;
  }
`;

const SectionOneTitle = styled(Title)`
  color: #ffffff;
  line-height: 1.2;
  /* margin-left: 3rem; */
  @media (max-width: 1024px) {
    text-align: center;
  }
  @media (max-width: 768px) {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    margin-left: 0;
  }
`;

const HeroSubTitle = styled(SectionParent)`
  padding-top: 1.5rem;
  /* margin-left: 3rem;
  margin-right: 3rem; */
  padding: 0 14rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  /* text-shadow: 0px 1px #000000; */
  letter-spacing: normal;
  color: #ffffff;
  text-align: center;
  @media (max-width: 1440px) and (min-width: 780px) {
    padding: 0rem 15rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    line-height: 1.14;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

const BlueButtonWrapper = styled.div`
  /* margin-left: -10px; */
  margin-top: 48px;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;
const HeroDomainItemImg = styled(LazyLoadImage)`
  max-width: 70%;
  @media (max-width: 520px) {
    /* width: 80%; */
    justify-self: center;
  }
  margin-top: 4rem;
  margin-bottom: 4rem;
`;

const BlueButtonNew = styled(BlueButton)`
  box-shadow: 0 3px 13px 0 #2a2f46;
`;
export default () => (
  <div>
    <SectionOne>
      <SectionItemContainer>
        <HeroDomainItemImg src={Android} />
        <SectionOneTitle>
          Bring Android to your x86 Device with Esper
        </SectionOneTitle>
        <HeroSubTitle style={{ paddingTop: '1rem' }}>
          Extend the life of vulnerable Windows systems by migrating them to
          Android. Take advantage of x86 hardware for Retail POS, digital
          signage, and kiosks with Esper. Enterprises can now use x86 hardware
          to run Android applications on device fleets using Esper solution.
        </HeroSubTitle>
        <BlueButtonWrapper>
          <BlueButtonNew
            id="android_x86__find_out_more"
            onClick={() => navigate('/signup')}
          >
            Find Out More
          </BlueButtonNew>
        </BlueButtonWrapper>
      </SectionItemContainer>
    </SectionOne>
  </div>
);
